import { Telegram } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const SendIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Telegram width={size} height={size} color={color} {...rest} />;

SendIcon.displayName = 'SendIcon';

export default SendIcon;
